import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { DEGREE_LABELS } from '@/lib/scales';
import { pitchClass } from '@/lib/pitch';

export const ScaleEditor = ({ open, initial, rootPc, flats, onSave, onDelete, onClose }) => {
  const [name, setName] = useState('');
  const [steps, setSteps] = useState([0]);

  useEffect(() => {
    if (!open) return;
    setName(initial?.name || '');
    setSteps(initial?.steps || [0, 2, 4, 5, 7, 9, 11]);
  }, [open, initial]);

  const toggle = (s) => {
    if (s === 0) return;
    setSteps((prev) => (prev.includes(s) ? prev.filter((x) => x !== s) : [...prev, s].sort((a, b) => a - b)));
  };
  const valid = name.trim().length > 0 && steps.length >= 2;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="scale-editor" className="bg-[#111112] border-white/10 text-white max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="font-bebas text-3xl tracking-wide">{initial ? 'Modifica scala' : 'Nuova scala'}</DialogTitle>
          <DialogDescription className="text-white/50">Tocca i gradi da includere (il grado 1 è sempre presente).</DialogDescription>
        </DialogHeader>
        <input
          data-testid="scale-editor-name"
          value={name}
          maxLength={40}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nome (es. My Hijaz)"
          className="h-11 rounded-xl bg-[#0A0A0A] border border-white/10 px-3 text-sm focus:outline-none focus:border-pink-400"
        />
        <div className="grid grid-cols-6 gap-1.5">
          {DEGREE_LABELS.map((label, s) => {
            const on = steps.includes(s);
            return (
              <button
                key={s}
                data-testid={`scale-editor-degree-${s}`}
                onClick={() => toggle(s)}
                className={`h-14 rounded-xl border flex flex-col items-center justify-center transition-colors ${on ? 'bg-pink-400 text-black border-pink-400' : 'border-white/10 text-white/70 hover:bg-white/5'} ${s === 0 ? 'cursor-default' : ''}`}
              >
                <span className="font-bebas text-xl leading-none">{pitchClass((rootPc + s) % 12, flats)}</span>
                <span className="text-[9px] font-mono opacity-70">{label}</span>
              </button>
            );
          })}
        </div>
        <div className="flex gap-2 pt-2">
          {initial && (
            <button data-testid="scale-editor-delete" onClick={() => onDelete(initial.id)} className="h-11 px-4 rounded-full border border-rose-400/40 text-rose-300 text-xs uppercase tracking-[0.2em] hover:bg-rose-500/10">Elimina</button>
          )}
          <button
            data-testid="scale-editor-save"
            disabled={!valid}
            onClick={() => onSave({ id: initial?.id, name: name.trim(), steps })}
            className="flex-1 h-11 rounded-full bg-pink-400 text-black text-xs font-semibold uppercase tracking-[0.2em] hover:bg-pink-300 disabled:opacity-40 active:scale-95 transition-transform"
          >
            Salva
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
